export default __webpack_public_path__ + "static/media/icon-activity-commentcreated.36db8c53.svg";